import React from 'react';
import { Link } from 'react-router';
import './Nav.css';

const propTypes = {
  children: React.PropTypes.object
}

const Nav = props => (
  <nav className='nav'>
    <Link
      to='/'
      className='nav__link'
      activeClassName='nav__link--is-active'>
      Clock
    </Link>
    <Link
      to='/alarms'
      className='nav__link'
      activeClassName='nav__link--is-active'>
      Alarms
    </Link>
    <Link
      to='/tasks'
      className='nav__link'
      activeClassName='nav__link--is-active'>
      Tasks
    </Link>
    <Link
      to='/weather'
      className='nav__link'
      activeClassName='nav__link--is-active'>
      Weather
    </Link>
  </nav>
)

Nav.propTypes = propTypes;

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js